/** Представление (вид) таблицы. */
export enum TableView {
    /** Таблица. */
    Table = "table",

    /** Карточки. */
    Cards = "cards",
}
